import { useContext, useEffect } from "react";
import { useNavigate,useParams } from "react-router-dom";
import Button from "@mui/material/Button";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AssignmentIcon from '@mui/icons-material/Assignment';
import Application from "../../../components/application";
import useVideosState from "../../../hooks/useVideosState";
import GridView from "../../../components/views/gridView";
import MyYoutube from "../../../components/myYoutube";
import MyEstrelas from "../../../components/myEstrelas";
import {Tooltip } from "@mui/material";
import TELAS from "../../../constants/telas";
import { AuthContext } from "../../../contexts/auth";
import TELA_ACOES from "../../../constants/telaAcoes";
import permissaoTelas from "../../../utils/permissaoTelas";

const PAGINA = {
    aplicacao: 'SisPalo - Colaborador',
    funcionalidade: 'Cursos',
    tela: TELAS.CURSOS,
    acoes: [TELA_ACOES.Incluir, TELA_ACOES.Alterar, TELA_ACOES.Consultar, TELA_ACOES.Apagar]
}

const Videos = () => {

    const states = useVideosState()
    const navigate = useNavigate()
    const { idCurso } = useParams()
    const {permissaoUsuario} = useContext(AuthContext); /* permissão para telas*/    
 
    useEffect(()=>{
        if (idCurso && states.pesquisa.value === ''){
            states.submit.set(idCurso)
        }
    }, [states.pesquisa.value])

    useEffect(()=>{
        /* permissão para telas*/
        if (permissaoTelas(permissaoUsuario,TELA_ACOES.Incluir, PAGINA)
            || permissaoTelas(permissaoUsuario,TELA_ACOES.Alterar, PAGINA)
            || permissaoTelas(permissaoUsuario,TELA_ACOES.Consultar, PAGINA)){
        }
        else{
            navigate('/gestor/dashboard')
        }
    }, [])

    let curso_name = ''

    if (states.videos.value.length > 0){
        curso_name = states.videos.value[0]?.curso_name
    }

    const columns = [
        //{field:'id', headerName:'ID', width: 80},
        {field:'sequencia', headerName:'Sequência', width: 80}, 
        {field:'name', headerName:'Nome Video', flex: 1, width: 300},
        {field:'descricao', headerName:'Descrição', flex: 1, width: 300},
        {field:'Média', headerName:'Média', width:130, renderCell: (cellValues) =>{
            return (
                    <>
                      <MyEstrelas nota={cellValues.row.media} titulo={cellValues.row.media}/>            
                    </>
        )
        }},  
        {field:'link_video2', headerName:'Youtube', width:70, renderCell: (cellValues) =>{
            return (
                 <MyYoutube embedId={cellValues.row.link_video} width='70' height='30' title={cellValues.row.name}/>
            )
        }},
        {field:'link_video', headerName:'ID youtube', width: 100},    
        {field:'numero_videos_visto', headerName:'Ações', width:100, renderCell: (cellValues) =>{
            return (
                <>
                    <Tooltip title="Apagar" placement="bottom" arrow>
                        <Button color='error' 
                                disabled={cellValues.row.numero_videos_visto > 0 || !permissaoTelas(permissaoUsuario,TELA_ACOES.Apagar, PAGINA)} 
                                onClick={()=>{states.itemDelete.set(cellValues.row);states.openDialog.set(true)}} 
                                sx={{width:'55px', padding: 0,minWidth:0}}><DeleteIcon />
                        </Button>                    
                    </Tooltip>                
                    <Tooltip title="Editar" placement="bottom" arrow>
                        <Button disabled={!permissaoTelas(permissaoUsuario,TELA_ACOES.Alterar, PAGINA)} onClick={()=>navigate(`/gestor/curso/${idCurso}/video/${cellValues.row.id}`)} sx={{width:'55px', padding: 0,minWidth:0}}><EditIcon /></Button>
                    </Tooltip>       
                    <Tooltip title="Visto por" placement="bottom" arrow>
                        <Button 
                            disabled={cellValues.row.numero_videos_visto < 1} 
                            onClick={()=>navigate(`/gestor/curso/${idCurso}/videovisto/${cellValues.row.id}`)} 
                            sx={{width:'55px', padding: 0,minWidth:0}}><AssignmentIcon />
                        </Button>
                    </Tooltip>                               
                </>
            )
        }}   
    ]

    return (
   
        <Application>
            <>
             <GridView 
                title={`Lista de Videos do Curso: ${curso_name}`}
                states={states}
                rows={states.videos.value}
                columns={columns}
                urlAdd={permissaoTelas(permissaoUsuario,TELA_ACOES.Incluir, PAGINA)?`/gestor/curso/${idCurso}/video` : null}
                onClickPesquisa={()=>{states.submit.set(idCurso)}}
                urlVoltar='/gestor/cursos'
                nomeItem='video'
             />
            </>
        </Application>
   
    )
}

export default Videos;
